import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { Box, Typography } from '@material-ui/core'
import { mutualTheme } from '~/utils/theme'
import ArrowForward from '@material-ui/icons/ArrowForwardIosRounded'
import { useIsMobileScreen } from '~/hooks'

const useStyles = makeStyles({
  navigationFlowText: {
    color: mutualTheme.palette.textGray2.main
  },
  arrowContainer: {
    marginLeft: mutualTheme.spacing(1),
    marginRight: mutualTheme.spacing(1)
  },
  arrow: {
    color: mutualTheme.palette.textGray2.main,
    fontSize: 12
  },
  title: {
    fontWeight: 'bold',
    marginTop: mutualTheme.spacing(1),
    marginBottom: mutualTheme.spacing(1)
  },
  description: {
    marginBottom: mutualTheme.spacing(4)
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  },
  innerContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  header: {
    fontWeight: 'bold',
    marginTop: mutualTheme.spacing(1),
    marginBottom: mutualTheme.spacing(2)
  }
})

export type DocumentationOnboardHeaderProps = {
  actions?: React.ReactNode,
  title: string | JSX.Element,
  description?: string | JSX.Element,
  customHeader?: string
}

export const DocumentationOnboardHeader: React.FC<DocumentationOnboardHeaderProps> = (props) => {
  const { title, description, actions, customHeader } = props
  const classes = useStyles()
  const isMobile = useIsMobileScreen()

  return (
    <Box className={classes.container}>
      <Box className={classes.innerContainer}>
        <Box className={classes.headerContainer}>
          <Typography variant={isMobile ? 'airbnbBody2' : 'airbnbBody1'} className={classes.navigationFlowText}>Solicitar empréstimo</Typography>
          <Box className={classes.arrowContainer}>
            <ArrowForward className={classes.arrow} />
          </Box>
          <Typography variant={isMobile ? 'airbnbBody2' : 'airbnbBody1'} className={classes.navigationFlowText}>{customHeader || 'Documentos'}</Typography>
        </Box>
        <Box>
          {actions}
        </Box>
      </Box>
      <Box className={classes.titleContainer}>
        <Typography className={classes.header} variant={isMobile ? 'airbnbH3' : 'airbnbH2' }>{title}</Typography>
        {description && (
          <Typography variant={isMobile ? 'airbnbBody2' : 'airbnbBody1'} className={classes.description}>
            {description}
          </Typography>
        )}
      </Box>
    </Box>
  )
}
